import DynamicCardFeed from '../scripts/sections/DynamicCardFeed';
import DynamicProductFeed from '../scripts/sections/DynamicProductFeed';
import DynamicShopTheLook from '../scripts/sections/DynamicShopTheLook';
import DynamicSizeGuide from '../scripts/sections/DynamicSizeGuide';
import DynamicSizingExamples from '../scripts/sections/DynamicSizingExamples';

// Sections
import MainAnnouncementBar from '../scripts/sections/MainAnnouncementBar';
import MainCart from '../scripts/sections/MainCart';
import MainCollection from '../scripts/sections/MainCollection';
import MainHeader from '../scripts/sections/MainHeader';
import MainMinicart from '../scripts/sections/MainMinicart';
import MainProduct from '../scripts/sections/MainProduct';
import Sections from '../scripts/helpers/SectionManager';

import initAOS from '../scripts/global/initAos';
import initModals from '../scripts/global/initModals';
import initVideos from '../scripts/global/initVideos';

// Init global sections
const sections = new Sections();
sections.register(
  'main-announcement-bar',
  section => new MainAnnouncementBar(section),
);
sections.register('main-product', section => new MainProduct(section));
sections.register(
  'main-collection-grid',
  section => new MainCollection(section),
);
sections.register('main-header', section => new MainHeader(section));
sections.register('main-minicart', section => new MainMinicart(section));
sections.register('main-cart', section => new MainCart(section));
sections.register('main-search', section => new MainCollection(section));

sections.register(
  'dynamic-card-feed',
  section => new DynamicCardFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-product-feed',
  section => new DynamicProductFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-shop-the-look',
  section => new DynamicShopTheLook(section),
  { lazy: true },
);
sections.register(
  'dynamic-size-guide',
  section => new DynamicSizeGuide(section),
  { lazy: true },
);
sections.register(
  'dynamic-sizing-examples',
  section => new DynamicSizingExamples(section),
  { lazy: true },
);

initAOS();
initVideos();
initModals();
